"use strict";

import angular from "angular";
/**
 * @component NuDataShowtime
 * O <nu-data-showtime> è um componente que é usado para um form do showtime contendo descrição e um campo de reviews e comentários
 */

import template from "./data-showtime.component.html";
import "./data-showtime.component.scss";

const name = "nuDataShowtime";
const def = {
    factory: [
        function () {
            return {
                template
            };

        }
    ]
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
